<template>
  <div>
    <div v-if="invoiceList.length">
      <b-table
        id="invoices"
        stacked="sm"
        :per-page="paginationData.perPage"
        :current-page="paginationData.currentPage"
        hover
        :fields="fields"
        :items="invoiceList"
      >
        <template #head(status)>
          Status
          <i v-b-tooltip.hover title="Status for oppgjør" class="fa fa-info-circle hoverable"></i>
        </template>

        <template #head(download)>
          Last ned
          <i
            v-b-tooltip.hover
            title="Last ned bilag for oppgjøret"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template #head(total)>
          Total
          <i
            v-b-tooltip.hover
            title="Utsalgspris - provisjon(eks. mva)"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template #head(dato)>
          Dato
          <i
            v-b-tooltip.hover
            title="Måneden oppgjøret ble produsert"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>
        <template #cell(total)="data">
          <span v-if="isDatePassed(data.item.dato)">{{ parseInt(data.value.amount / 100).toFixed(2) }} kr</span>
        </template>

        <template #cell(dato)="data">
          {{ formatInvoiceDate(data.item) }}
        </template>
        <template #cell(download)="data">
          <a v-if="isDatePassed(data.item.dato)" href="#" @click.prevent="downloadInvoice(data.value)"><i class="fa fa-download"></i></a>
          <span v-else>Vennligst kontakt support@youwish.no</span>
        </template>
      </b-table>
      <b-pagination
        v-model="paginationData.currentPage"
        :total-rows="invoiceList.length"
        :per-page="paginationData.perPage"
        aria-controls="invoices"
      ></b-pagination>
    </div>
    <b-alert :show="invoiceList.length === 0" variant="dark" class="text-center">
      <strong>Listen er tom!</strong> Løs inn verdibevis for å motta oppgjør
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { format, subDays, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';
import { invoices } from '@/api';

export default {
  data() {
    return {
      rootUrl: process.env.VUE_APP_API_URL,
      fields: ['status', 'dato', 'total', { key: 'download', label: 'Last ned' }],
      paginationData: {
        perPage: 10,
        currentPage: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      invoiceList: 'invoices/invoiceTable',
    }),
  },
  methods: {
    formatInvoiceDate(invoice) {
      let invoiceDate = parseISO(invoice.dato);

      if (!invoice.is_manual) {
        invoiceDate = subDays(invoiceDate, 1);
      }

      return format(invoiceDate, 'MMMM yyyy', { locale: nb });
    },

    async downloadInvoice(id) {
      const res = await invoices.download(id)
      window.open(res.url, '_blank').focus()
    },

    isDatePassed(date) {
      const targetDate = new Date('2024-08-06');
      // return parseISO(date) > targetDate;
      const blockingDate = new Date('2025-04-30');
      return parseISO(date) > targetDate && parseISO(date) < blockingDate;
    },
  },
};
</script>
